import React from 'react';
import { MapPin, Users } from 'lucide-react';
import  NoImageAvailable from '../no-image-available.png';
import axiosInstance from '../../api/axios';

const VenueList = ({ venues, updateMessages })  => {
    console.log("venues" + venues);
  if (!venues || venues.length === 0) {
    return <div className="p-4 text-gray-500"></div>;
  }

  const processedVenues = venues.map(venue => ({
    ...venue,
    image_url: venue.yelp_photos_url?.split(',')[0] || null,
  }));

  const requestQuoteSelectedOnes = async () => {
    const checkedCheckboxIds = Array.from(document.querySelectorAll('input[type="checkbox"]:checked')).map(checkbox => checkbox.id.replace('requestQuote-', ''));
    console.log("checkedCheckboxIds" + checkedCheckboxIds);
    sendQuoteRequests(checkedCheckboxIds);
  }

  const sendQuoteRequests = async (ids) => {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        const chat_session_id =  localStorage.getItem('sessionId');
        const userId = user?.id;  // Using optional chaining
        if (userId) {
            // Replace with your Dialogflow API endpoint
            const response = await axiosInstance.post('/quotes', {
                venue_ids: ids,
                chat_session_id: chat_session_id,
                user_id: userId
            });
            console.log("response: " + response);
            // Get the response text from Dialogflow
            const data = response.data;
            console.log("data: " + data);
            if (data) {
                updateMessages('The quotes are requested from the venues');
            }
            else {
                updateMessages('There are some issues in requesting the quotes. Please try again later');
            }
        } else {
            updateMessages('There are some issues in requesting the quotes. Please try again later');
        }
      } catch (error) {
        updateMessages('There are some issues in requesting the quotes. Please try again later')
      }
  }

  const requestQuoteAll = async () => {
    console.log("requestQuoteAll");
    const CheckboxIds = Array.from(document.querySelectorAll('input[type="checkbox"]:checked')).map(checkbox => checkbox.id.replace('requestQuote-', ''));
    console.log("CheckboxIds" + CheckboxIds);
    sendQuoteRequests(CheckboxIds);
  }

  return (
  <div>
      <div className="mt-2 flex items-center gap-4">
        <button 
            className="w-44 px-6 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors text-center"
            onClick={requestQuoteAll}
        >
            Request Quote for all venues
        </button>
        <button 
            className="w-44 px-6 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors text-center"
            onClick={requestQuoteSelectedOnes}
        >
            Request Quote from selected
        </button>
      </div>
 
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">

      {processedVenues.map((venue, index) => (
        <div 
          key={index} 
          className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-4 border border-gray-200"
        >
          {/* Card Header */}
          <div className="mb-4">
            <h2 className="text-lg font-bold text-gray-900">
              {venue.name}
            </h2>
            {
                venue.image_url ? <img src={venue.image_url} alt="Venue" /> : <img src={NoImageAvailable} alt="No Image Available" />
            }
          </div>

          {/* Card Content */}
          <div className="space-y-4">
            {/* Address Section */}
            <div className="flex items-start gap-2">
              <MapPin className="w-5 h-5 mt-1 text-gray-500" />
              <div>
                <p className="text-sm text-gray-600">Address</p>
                <p className="text-gray-900">{venue.address}</p>
                <p className="text-sm text-gray-500">{(venue.distance_meters * 0.000621371).toFixed(2)} mi</p>
              </div>
            </div>
            
            {/* Capacity Section */}
            <div className="flex items-start gap-2">
              <Users className="w-5 h-5 mt-1 text-gray-500" />
              <div>
                <p className="text-sm text-gray-600">Capacity</p>
                <p className="text-gray-900">{venue.capacity} people</p>
              </div>
            </div>

            {/* Score Section */}
            <div>
              <p className="text-sm text-gray-600">Score</p>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className="bg-blue-600 h-2 rounded-full" 
                  style={{width: `${(venue.avg_rating / 5) * 100}%`}}
                ></div>
              </div>
              <p className="text-sm text-gray-500 mt-1">{((venue.avg_rating / 5) * 100).toFixed(0)}%</p>
            </div>
            <div className="mt-2 flex items-center">
                <input 
                    id={`requestQuote-${venue.id}`}
                    type="checkbox" 
                    className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                />
                <label 
                    htmlFor={`requestQuote-${venue.id}`}
                    className="ml-2 text-sm text-gray-600"
                >
                    Request Quote
                </label>
            </div>

            {/* Amenities Section (only shown if amenities exist) */}
            {venue.Venue_Amenities && (
              <div>
                <p className="text-sm text-gray-600">Amenities</p>
                <p className="text-gray-900">{venue.Venue_Amenities}</p>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
       <div className="mt-2 flex items-center gap-4">
        <button 
            className="w-44 px-6 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors text-center"
            onClick={requestQuoteAll}
        >
            Request Quote for all venues
        </button>
        <button 
            className="w-44 px-6 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors text-center"
            onClick={requestQuoteSelectedOnes}
        >
            Request Quote from selected
        </button>
      </div>
  </div>
  );
};

export default VenueList;
